import './AssetsSkeleton.css';

export default function AssetsSkeleton() {
	return (
		<div id="assets-skeleton" className="skeleton">
			<h3 className="skeleton-element" />
			<ul className="asset-list">
				<li className="skeleton-element"></li>
				<li className="skeleton-element"></li>
				<li className="skeleton-element"></li>
				<li className="skeleton-element"></li>
				<li className="skeleton-element"></li>
				<li className="skeleton-element"></li>
			</ul>
		</div>
	);
}
